import { render, staticRenderFns } from "./ByCustomer.vue?vue&type=template&id=2f6ae48e&scoped=true&"
import script from "./ByCustomer.vue?vue&type=script&lang=js&"
export * from "./ByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ByCustomer.vue?vue&type=style&index=0&id=2f6ae48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ae48e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
